// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2XnNz","title":"ClientReferral_title__1FNSI","itemText":"ClientReferral_itemText__GeOe_"};